import { GroupBase, OptionProps, components } from "react-select";
import { SelectItem } from "../Select";
import Icon from "../../icon/Icon";

const Option = (
  props: OptionProps<SelectItem, false, GroupBase<SelectItem>>,
) => (
  <components.Option {...props} innerRef={props.innerRef}>
    <div className="flex flex-row items-center gap-2">
      {props.isMulti && (
        <>
          {props.isSelected ? (
            <Icon name="checkbox-checked" />
          ) : (
            <Icon name="checkbox-unchecked" />
          )}
        </>
      )}
      <div className="flex-1">
        <div
          className={`font-medium ${props.data.value === "" ? "opacity-50" : ""}`}
        >
          {props.children}
        </div>
        {props.data.description && (
          <div className="text-gray-dark truncate text-[12px]/[16px]">
            {props.data.description}
          </div>
        )}
      </div>
    </div>
  </components.Option>
);

export default Option;
